import { defineStore } from 'pinia';

export type Breadcrumb = {
  label: string;
  to: string | { name: string; hash?: string; params?: Record<string, string | undefined> };
  index: number;
  isClickable?: boolean;
  /**
   * Opts a crumb out of the trail's last-is-current default. Set it `false` on a final crumb that
   * is still a parent of what is on screen — the BOQ trail ends at the site while the user is on a
   * tab within it, so that crumb stays navigable (PLE-1406).
   */
  isCurrent?: boolean;
};

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: () => ({
    items: [] as Breadcrumb[],
    /**
     * Set by a view that has to fetch a crumb label (typically after a refresh, where
     * this store starts empty) so the layout shows the breadcrumb skeleton instead of
     * an empty header. Cleared by `setBreadcrumbs`.
     */
    isLoading: false,
  }),

  actions: {
    setBreadcrumbs(breadcrumbs: Breadcrumb[]) {
      this.items = breadcrumbs;
      this.isLoading = false;
    },

    setLoading(isLoading: boolean) {
      this.isLoading = isLoading;
    },

    updateBreadcrumbs(breadcrumbs: Breadcrumb[]) {
      breadcrumbs.forEach((breadcrumb: Breadcrumb) => {
        this.items.push(breadcrumb);
      });
    },
  },
});
